var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContentDelivery = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7 0q.51 0 1.001.071v2.03a5 5 0 1 0 0 9.8v2.028A7 7 0 1 1 7 0m5 3 3.654 3.321a.897.897 0 0 1 0 1.358L12 11h-.508a.99.99 0 0 1-.993-.992V9.5L12.633 8H7V6h5.634L10.5 4.5v-.508c0-.548.442-.992.993-.992z"
})));
export default SvgContentDelivery;